import React from 'react';
import { BadgeCheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { CTA_LABEL, PRICE } from '../data/content';
export function GuaranteeSection() {
  return <section className="border-b border-ink-700 bg-ink-900" data-id="element-43" data-mp="9umi0wj5pw9e">
      <div className="mx-auto max-w-4xl px-5 py-14 sm:py-20" data-id="element-44" data-mp="9t1nh6wuedbj">
        <div className="rounded-3xl border border-safe-500/35 bg-safe-500/[0.06] p-6 text-center sm:p-10" data-id="element-45" data-mp="euh8iyz0sjtx">
          <span className="mx-auto mb-5 inline-flex h-14 w-14 items-center justify-center rounded-full bg-safe-500/15 text-safe-500" data-id="element-46" data-mp="jrhc938edahv">
            <BadgeCheckIcon className="h-7 w-7" aria-hidden="true" data-id="element-47" data-mp="ns19e6sz0e40" />
          </span>
          <h2 className="font-display text-2xl font-extrabold tracking-tight text-white sm:text-3xl" data-id="element-48" data-mp="slmcgd9f7ya2">
            Garantía de Blindaje
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-base leading-relaxed text-slate-300" data-id="element-49" data-mp="12jjz4wbmtn0k">
            Si después de leer la guía sentís que no aprendiste nada nuevo para protegerte, te
            devuelvo el dinero sin preguntas.{' '}
            <span className="font-semibold text-white" data-id="element-50" data-mp="25sqbjc1ncxbb">Mi objetivo es tu seguridad.</span>
          </p>
        </div>

        <div className="mt-10 flex justify-center" data-id="element-51" data-mp="20rj0930apfzw">
          <CtaButton label={CTA_LABEL} sublabel={`${PRICE} ARS · Pago único`} data-id="element-52" data-mp="1vszcqy61zw5f" />
        </div>
      </div>
    </section>;
}